import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"

import InternLinks from "../components/internlinks";
import { FaCheck } from 'react-icons/fa';

const IndexPage = () => (
  <Layout2>
     <SEO title="Oral B Junior Mimmi" description="Recension av Oral B Junior D501 Minnie 6+" keywords={[`Oral B`, `Vita tänder`, `Eltandborste`, `barntandborste`, ` Minnie 6+`]}/>
     <section className="section-produkter">
       <article>
       <div className="prod-text">
          <h1>Mimmi 6+ Eltandborste </h1>
         </div>
      </article>
      <article class="right">
        <img src="../mimmi.webp" alt="Minnie 6+ Eltandborste"/>
        <aside>
          <h3 class="erbj-pris">599:-</h3>
          <h2>Mimmi 6+</h2>
          <p class="prod-beskrivning">
          </p>
          <a href="https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-junior-d501-minnie-6--ar-eltandborste" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
          <ul>
             <li><FaCheck className="li-icon" />Extra mjuka borststrån</li>
             <li><FaCheck className="li-icon" />Roligt med Disney MagicTimer app</li>
             <li><FaCheck className="li-icon" />Litet runt borsthuvud</li>
          </ul>
        </aside>
        <div className="prod-text"><h5>Junior D501 Mimmi 6+ år Eltandborste</h5>
         <p>Oral-B Junior Mimmi från 6 år är utformad med tandläkare för en överlägsen rengöring. För att 
             skydda barns ömtåliga tandkött har den en tryckkontroll för tandköttet som blinkar med rött ljus och 
             saktar in borstningshastigheten när den känner att borstningen är för hård. Dessutom har det runda 
             borsthuvudet extramjuka borststrån. För att göra tandborstningen roligare kan den användas med den kostnadsfria
              appen Disney Magic Timer från Oral-B. 90 % av barnen borstar faktiskt längre med appen. 
              Det är en rätt borste för att hjälpa barn borsta självständigt och utveckla sunda tandborstningsvanor för hela livet.
             Mycket omtyckt bland barnen och smidigt med signalen som de väntar på, det gör det skoj och enkelt att borsta tänderna morgon som kväll. 
         </p>
        </div>
      </article>

       </section>
       {/* <section className="section-cards">
    <main>
    <h2 class="rubrik-tandblekning">Bästa tandblekningen hemma</h2>
       <Card />
       </main>
  </section> */}

  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  </Layout2>
)

export default IndexPage
